import firebase from "firebaseFactory";

export {
  useAuthDataContext,
  AuthDataProvider,
  UserRole,
  Permissions,
} from "./components/AuthDataContext";
export { SignInPage } from "./pages/SignInPage";

export const sendPasswordResetEmail = async (email: string) => {
  // including the url parameter ensures that firebase's
  // built in reset password flow will then take users
  // to the login page
  await firebase.auth().sendPasswordResetEmail(email, { url: getAppUrl() });
};
export const getAppUrl = () =>
  `${window.location.protocol}//${window.location.host}/`;
